import { useMemo, useState, useEffect } from 'react';
import copy from 'copy-to-clipboard';
import i18n from '@dragonfruit/i18n';

const COPY = 'copy';
const REDIRECT = 'redirect';

export default function({ clickType, link, desc, linkText }) {
  const [bannerBtnText, setBannerText] = useState(linkText);

  useEffect(() => {
    setBannerText(linkText);
  }, [linkText]);

  const bannerCallback = useMemo(() => {
    switch (clickType) {
      case REDIRECT:
        return () => window.open(link, '_target');

      case COPY:
        return () => {
          copy(link);
          //This is a workaround, I can't get t function through context here.
          //Once You call useContext in this custom hook, the whole process will crash without message.
          setBannerText(i18n.t('premium:premium.copiedDiscountCode'));
          setTimeout(() => setBannerText(linkText), 1500);
        };

      default:
        return () => {};
    }
  }, [clickType, link, linkText]);

  return {
    bannerCallback,
    bannerBtnText,
    bannerDescription: desc,
  };
}



// WEBPACK FOOTER //
// ./app/hooks/usePromotionBannerCallback.js